import React, { FC } from 'react';
import { Text } from 'react-native';
import SettingsScreenStyles from './Settings.styles';

interface SectionHeadingProps {
  title: string;
  testID: string;
}

const SectionHeading: FC<SectionHeadingProps> = ({ title, testID }) => {
  const styles = SettingsScreenStyles();

  return (
    <Text testID={testID} style={styles.subheading}>
      {title}
    </Text>
  );
};

export default SectionHeading;
